<ng-container [formGroup]="formGroup">
  <div class="case-info-title">Case Information</div>

  <p-panel 
    *ngIf="showPanel" 
    styleClass="border-0 panel-dotted-heading mt-3" 
    [header]="headerText">
    <div class="row mb-0 mb-lg-3">
      <!-- Case Number -->
      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
        <label 
          [for]="idPrefix + '-case-number'" 
          class="form-label d-block required-asterisk">
          Case Number
        </label>
        <input 
          pInputText 
          type="text" 
          [id]="idPrefix + '-case-number'" 
          class="w-100" 
          placeholder="Enter case number"
          formControlName="caseNumber" 
          [ngClass]="{'ng-invalid ng-dirty' : isError('caseNumber')}"
          [readonly]="isReadOnly" />
        <small 
          [id]="idPrefix + '-case-number-error'" 
          *ngIf="isError('caseNumber')" 
          class="error-label">
          {{ getErrorMessage('caseNumber') }}
        </small>
      </div>

      <!-- Case Name -->
      <div class="col-sm-12 col-md-12 col-lg-9 mb-3">
        <label 
          [for]="idPrefix + '-case-name'" 
          class="form-label d-block required-asterisk">
          Case Name
        </label>
        <input 
          pInputText 
          type="text" 
          [id]="idPrefix + '-case-name'" 
          class="w-100" 
          placeholder="Enter case name"
          formControlName="caseName" 
          [ngClass]="{'ng-invalid ng-dirty' : isError('caseName')}"
          [readonly]="isReadOnly" />
        <small 
          [id]="idPrefix + '-case-name-error'" 
          *ngIf="isError('caseName')" 
          class="error-label">
          {{ getErrorMessage('caseName') }}
        </small>
      </div>

      <!-- Judge -->
      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
        <label 
          [for]="idPrefix + '-judge'" 
          class="form-label d-block">
          Judge
        </label>
        <input 
          pInputText 
          type="text" 
          [id]="idPrefix + '-judge'" 
          class="w-100" 
          placeholder="Enter judge"
          formControlName="judge"
          [readonly]="isReadOnly" />
      </div>

      <!-- Court -->
      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
        <label 
          [for]="idPrefix + '-court'" 
          class="form-label d-block required-asterisk">
          Court
        </label>
        <input 
          pInputText 
          type="text" 
          [id]="idPrefix + '-court'" 
          class="w-100" 
          placeholder="Enter court"
          formControlName="court" 
          [ngClass]="{'ng-invalid ng-dirty' : isError('court')}"
          [readonly]="isReadOnly" />
        <small 
          [id]="idPrefix + '-court-error'" 
          *ngIf="isError('court')" 
          class="error-label">
          {{ getErrorMessage('court') }}
        </small>
      </div>

      <!-- Court Street Address -->
      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
        <label 
          [for]="idPrefix + '-court-street-address'" 
          class="form-label d-block">
          Court Street Address
        </label>
        <input 
          pInputText 
          type="text" 
          [id]="idPrefix + '-court-street-address'" 
          class="w-100"
          placeholder="Enter court street address" 
          formControlName="courtStreetAddress"
          [readonly]="isReadOnly" />
      </div>

      <!-- City -->
      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
        <label 
          [for]="idPrefix + '-court-city'" 
          class="form-label d-block">
          City
        </label>
        <input 
          pInputText 
          type="text" 
          [id]="idPrefix + '-court-city'" 
          class="w-100" 
          placeholder="Enter city"
          formControlName="cityName"
          [readonly]="isReadOnly" />
      </div>

      <!-- Jurisdiction County -->
      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
        <label 
          [for]="idPrefix + '-jurisdiction-county'" 
          class="form-label d-block required-asterisk">
          Jurisdiction County
        </label>
        <input 
          pInputText 
          type="text" 
          [id]="idPrefix + '-jurisdiction-county'" 
          class="w-100"
          placeholder="Enter jurisdiction county" 
          formControlName="jurisdictionCounty"
          [ngClass]="{'ng-invalid ng-dirty' : isError('jurisdictionCounty')}"
          [readonly]="isReadOnly" />
        <small 
          [id]="idPrefix + '-jurisdiction-county-error'" 
          *ngIf="isError('jurisdictionCounty')" 
          class="error-label">
          {{ getErrorMessage('jurisdictionCounty') }}
        </small>
      </div>

      <!-- State -->
      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
        <label 
          [for]="idPrefix + '-state'" 
          class="form-label d-block">
          State
        </label>
        <p-select 
          formControlName="state" 
          [id]="idPrefix + '-state'" 
          [options]="states" 
          optionLabel="name"
          placeholder="Select state" 
          styleClass="w-100"
          [disabled]="isReadOnly" />
      </div>

      <!-- Zip -->
      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
        <label 
          [for]="idPrefix + '-zipcode'" 
          class="form-label d-block">
          Zip
        </label>
        <input 
          pInputText 
          type="text" 
          [id]="idPrefix + '-zipcode'" 
          class="w-100" 
          placeholder="Enter zip"
          formControlName="zipCode"
          [readonly]="isReadOnly" />
      </div>
    </div>
  </p-panel>

  <!-- Alternative layout without panel wrapper -->
  <div *ngIf="!showPanel" class="case-information-wrapper">
    <h3 *ngIf="headerText" class="section-header">{{ headerText }}</h3>
    <div class="row mb-0 mb-lg-3">
      <!-- Same fields as above, without panel wrapper -->
      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
        <label 
          [for]="idPrefix + '-case-number'" 
          class="form-label d-block required-asterisk">
          Case Number
        </label>
        <input 
          pInputText 
          type="text" 
          [id]="idPrefix + '-case-number'" 
          class="w-100" 
          placeholder="Enter case number"
          formControlName="caseNumber" 
          [ngClass]="{'ng-invalid ng-dirty' : isError('caseNumber')}"
          [readonly]="isReadOnly" />
        <small 
          [id]="idPrefix + '-case-number-error'" 
          *ngIf="isError('caseNumber')" 
          class="error-label">
          {{ getErrorMessage('caseNumber') }}
        </small>
      </div>

      <div class="col-sm-12 col-md-12 col-lg-9 mb-3">
        <label 
          [for]="idPrefix + '-case-name'" 
          class="form-label d-block required-asterisk">
          Case Name
        </label>
        <input 
          pInputText 
          type="text" 
          [id]="idPrefix + '-case-name'" 
          class="w-100" 
          placeholder="Enter case name"
          formControlName="caseName" 
          [ngClass]="{'ng-invalid ng-dirty' : isError('caseName')}"
          [readonly]="isReadOnly" />
        <small 
          [id]="idPrefix + '-case-name-error'" 
          *ngIf="isError('caseName')" 
          class="error-label">
          {{ getErrorMessage('caseName') }}
        </small>
      </div>

      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
        <label 
          [for]="idPrefix + '-judge'" 
          class="form-label d-block">
          Judge
        </label>
        <input 
          pInputText 
          type="text" 
          [id]="idPrefix + '-judge'" 
          class="w-100" 
          placeholder="Enter judge"
          formControlName="judge"
          [readonly]="isReadOnly" />
      </div>

      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
        <label 
          [for]="idPrefix + '-court'" 
          class="form-label d-block required-asterisk">
          Court
        </label>
        <input 
          pInputText 
          type="text" 
          [id]="idPrefix + '-court'" 
          class="w-100" 
          placeholder="Enter court"
          formControlName="court" 
          [ngClass]="{'ng-invalid ng-dirty' : isError('court')}"
          [readonly]="isReadOnly" />
        <small 
          [id]="idPrefix + '-court-error'" 
          *ngIf="isError('court')" 
          class="error-label">
          {{ getErrorMessage('court') }}
        </small>
      </div>

      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
        <label 
          [for]="idPrefix + '-court-street-address'" 
          class="form-label d-block">
          Court Street Address
        </label>
        <input 
          pInputText 
          type="text" 
          [id]="idPrefix + '-court-street-address'" 
          class="w-100"
          placeholder="Enter court street address" 
          formControlName="courtStreetAddress"
          [readonly]="isReadOnly" />
      </div>

      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
        <label 
          [for]="idPrefix + '-court-city'" 
          class="form-label d-block">
          City
        </label>
        <input 
          pInputText 
          type="text" 
          [id]="idPrefix + '-court-city'" 
          class="w-100" 
          placeholder="Enter city"
          formControlName="cityName"
          [readonly]="isReadOnly" />
      </div>

      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
        <label 
          [for]="idPrefix + '-jurisdiction-county'" 
          class="form-label d-block required-asterisk">
          Jurisdiction County
        </label>
        <input 
          pInputText 
          type="text" 
          [id]="idPrefix + '-jurisdiction-county'" 
          class="w-100"
          placeholder="Enter jurisdiction county" 
          formControlName="jurisdictionCounty"
          [ngClass]="{'ng-invalid ng-dirty' : isError('jurisdictionCounty')}"
          [readonly]="isReadOnly" />
        <small 
          [id]="idPrefix + '-jurisdiction-county-error'" 
          *ngIf="isError('jurisdictionCounty')" 
          class="error-label">
          {{ getErrorMessage('jurisdictionCounty') }}
        </small>
      </div>

      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
        <label 
          [for]="idPrefix + '-state'" 
          class="form-label d-block">
          State
        </label>
        <p-select 
          formControlName="state" 
          [id]="idPrefix + '-state'" 
          [options]="states" 
          optionLabel="name"
          placeholder="Select state" 
          styleClass="w-100"
          [disabled]="isReadOnly" />
      </div>

      <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
        <label 
          [for]="idPrefix + '-zipcode'" 
          class="form-label d-block">
          Zip
        </label>
        <input 
          pInputText 
          type="text" 
          [id]="idPrefix + '-zipcode'" 
          class="w-100" 
          placeholder="Enter zip"
          formControlName="zipCode"
          [readonly]="isReadOnly" />
      </div>
    </div>
  </div>
</ng-container>

